import { render, staticRenderFns } from "./faq-form.vue?vue&type=template&id=648082fb&scoped=true"
import script from "./faq-form.vue?vue&type=script&lang=js"
export * from "./faq-form.vue?vue&type=script&lang=js"
import style0 from "./faq-form.vue?vue&type=style&index=0&id=648082fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648082fb",
  null
  
)

export default component.exports